import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useForm } from '@inertiajs/vue3';
    import { WorkCalendar } from '@/types';
    import DialogForm from '@/components/DialogForm.vue';
    import WorkCalendarForm from './WorkCalendarForm.vue';
    import QueryKey from '@/enums/QueryKey';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CreateWorkCalendar',
  setup(__props) {

    const form = useForm({
        name: '',
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DialogForm, {
    type: "create",
    form: _unref(form),
    route: _ctx.route('v2.salary.work-calendars.store'),
    "query-key": [_unref(QueryKey).WORK_CALENDARS],
    title: "work-calendars.create",
    "button-text": "work-calendars.create"
  }, {
    default: _withCtx(() => [
      _createVNode(WorkCalendarForm, { form: _unref(form) }, null, 8, ["form"])
    ]),
    _: 1
  }, 8, ["form", "route", "query-key"]))
}
}

})